export default {
  name: 'CauConfirmationScreen',
  components: {},
  props: {
    continueButtonAction: Function,
    memberProfile: {
      // AnalyticsHub events will not be tracked if this is not provided
      type: Object,
      required: true
    },
    metadata: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      agreeToAllTerms: false,
      agreeToAdditionalTerms: false
    };
  },
  computed: {
    readyToSubmit() {
      return this.agreeToAllTerms;
    }
  },
  watch: {
    agreeToAllTerms() {
      if (!this.agreeToAllTerms) {
        return;
      }
      this.$analyticsHub.track('Single Page CAU Started', {
        member_id: this.memberProfile.id,
        user_id: this.memberProfile.extra_user_id,
        plan_type: this.metadata.plan_type,
        plan_price: this.metadata.plan_cost,
        plan_frequency: this.metadata.billing_cycle,
        source: this.metadata.source
      });
    }
  },
  mounted() {
    this.$analyticsHub.track('Single Page CAU Viewed', {
      member_id: this.memberProfile.id,
      user_id: this.memberProfile.extra_user_id,
      plan_type: this.metadata.plan_type,
      plan_price: this.metadata.plan_cost,
      plan_frequency: this.metadata.billing_cycle,
      source: this.metadata.source
    });
  },
  methods: {
    onEvolvePrivacyLinkClick() {
      // Tracking this since if clicked in the native webview, the user will have to close
      // out and re-enter the webview from the cau full screen lock.
      // Want to see how many users hit this situation, basiclaly click this link.
      this.$analyticsHub.track('[Single Page CAU][Web] Evolve Privacy Link Click', {
        member_id: this.memberProfile.id,
        user_id: this.memberProfile.extra_user_id,
        plan_type: this.metadata.plan_type,
        plan_price: this.metadata.plan_cost,
        plan_frequency: this.metadata.billing_cycle,
        source: this.metadata.source
      });
    }
  }
};